import { handleErrors } from './ErrorActions';
import { getTranslatedColumnList } from '../api/translated-column-list';
import { getTranslatedColumnListKey } from '../utils/savedSearchUtils';

export const SET_TRANSLATED_COLUMN_LISTS = 'SET_TRANSLATED_COLUMN_LISTS';

export const setTranslatedColumnLists = (data) => ({
  type: SET_TRANSLATED_COLUMN_LISTS,
  payload: {
    data,
  },
});

export const fetchTranslatedColumnList = (
  entityName,
  savedSearchName,
  customFilter,
  metadata
) => async (dispatch) => {
  const { queryForDocRepository } = metadata?.params || {};

  const { TranslatedColumnList, hasError, errors } = await getTranslatedColumnList({
    entityName,
    savedSearchName,
    customFilter,
    queryForDocRepository,
  });

  if (hasError) {
    dispatch(handleErrors(errors));
    return;
  }

  const data = Object.keys(TranslatedColumnList).reduce((acc, columnName) => {
    const key = getTranslatedColumnListKey(savedSearchName, columnName);
    return { ...acc, [key]: TranslatedColumnList[columnName] };
  }, {});

  dispatch(setTranslatedColumnLists(data));
};
